import React, { useState, useEffect } from "react";
import authService from "../../services/AuthService";
import { useTranslation } from "react-i18next";
import { LegendSettings } from "./LegendSettings";
import { Typography } from "@mui/material";

export const WmsLegendComponent = ({ legend }) => {
  const { geoserver_layer_id, rule, style } = legend;

  const legend_wms = process.env.REACT_APP_GEOSERVER_URL_WMS;
  const base_url = process.env.REACT_APP_GEOSERVER_URL;
  const wmsUrl = base_url + legend_wms;

  const [legendSrc, setLegendSrc] = useState(null);
  const [hasLegend, setHasLegend] = useState(false);
  const { t, i18n } = useTranslation("main");

  // Función para construir la URL de la leyenda
  const getLegendUrl = (wmsUrl, geoserver_layer_id) => {
    const params_raw = {
      SERVICE: "WMS",
      REQUEST: "GetLegendGraphic",
      FORMAT: "image/png", // Puede ser image/png, image/jpeg, etc.
      WIDTH: 20, // Puedes ajustar el ancho de la leyenda
      HEIGHT: 20, // Puedes ajustar el alto de la leyenda
      LAYER: geoserver_layer_id, // El nombre de la capa
      VERSION: "1.3.0", // Asegúrate de usar la versión correcta del WMS
      TRANSPARENT: "true",
      LANGUAGE: i18n.language.toUpperCase(),
      // LANGUAGE: i18n.language,
    };
    if (rule) {
      params_raw["RULE"] = rule;
    }
    if (style && style.geoserver_style_id) {
      params_raw["STYLE"] = style.geoserver_style_id;
    }
    const params = new URLSearchParams(params_raw);
    return `${wmsUrl}?${params.toString()}`;
  };

  // Ejecutar cuando se monta el componente
  useEffect(() => {
    if (wmsUrl && geoserver_layer_id) {
      const legendGraphicUrl = getLegendUrl(wmsUrl, geoserver_layer_id);
      // setLegendUrl(legendGraphicUrl);
      const token = authService.getToken();
      let objectURL = false;
      if (token) {
        fetch(legendGraphicUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (!response.ok) {
              // Manejo de errores: aquí te das cuenta si el servidor respondió con 4xx o 5xx
              throw new Error(`Error HTTP ${response.status}`);
            }
            return response.blob();
          })
          .then((blob) => {
            objectURL = URL.createObjectURL(blob);
            setLegendSrc(objectURL);
            setHasLegend(true);
          })
          .catch((error) =>
            console.error("Error cargando la imagen de la leyenda:", error)
          );
      } else {
        // setLegendSrc(legendGraphicUrl);
        console.error("ERROR obteniendo la leyenda, no tengo token");
      }

      return () => {
        // Cleanup: Revocar el objectURL si existe
        if (objectURL) {
          URL.revokeObjectURL(objectURL);
        }
      };
    }
  }, [wmsUrl, geoserver_layer_id, rule, style, i18n.language]);

  return !hasLegend ? (
    <p>{t("loading_legend")}...</p>
  ) : (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <img
        // style={{ height: style ? "22px" : "" }}
        src={legendSrc}
        alt={`Leyenda de ${geoserver_layer_id}`}
      />
      {/* {style && <Typography>{style?.legend_title[i18n.language]}</Typography>} */}
      {style && <Typography>{style?.legend_title.en}</Typography>}
    </div>
  );
};

class WMSLegend extends LegendSettings {
  constructor({ geoserver_layer_id, style, rule }) {
    super();

    this.geoserver_layer_id = geoserver_layer_id;
    this.style = style;
    this.rule = rule;

    this.create_legend();
  }

  changeLegendStyle = (new_style) => {
    this.style = new_style;
    this.create_legend();
  };

  create_legend = () => {
    this.legend = <WmsLegendComponent legend={this} />;
  };
}
export { WMSLegend };
